import EmailVerificationPage from './EmailVerificationPage';
export { EmailVerificationPage };



// WEBPACK FOOTER //
// ./src/modules/email-verification/index.js